import { useEffect, useState, useRef } from 'react';
import { getChatHistory } from '../data/dataApi';
import { Link } from "react-router-dom";
import Sidebar from '../views/components/Sidebar';
import Topbar from '../views/components/Topbar';

const History = () => {
    const groupedHistory = {
        today: [],
        yesterday: [],
        previous_7_days: [],
        previous_30_days: [],
        last_month: [],
    };
    const [history, setHistory] = useState(groupedHistory);

    const effectRan = useRef(false);

    useEffect(() => {
        if (effectRan.current) return; // Dev mode fix

        (async () => {
            const response = await getChatHistory();

            if (response.success) {
                const { data } = response;

                for (const key of Object.keys(data)) {
                    const session = data[key];
                    const chat = session[0];
                    const sessionTime = new Date(chat.time);

                    sessionTime.setHours(sessionTime.getHours() - 5); // EST

                    const now = new Date();
                    const estNow = new Date(now.getTime() + -5 * 60 * 60 * 1000);
                    const today = new Date(estNow.getFullYear(), estNow.getMonth(), estNow.getDate());
                    const yesterday = new Date(today);
                    yesterday.setDate(today.getDate() - 1);
                    const previous7Days = new Date(today);
                    previous7Days.setDate(today.getDate() - 7);
                    const previous30Days = new Date(today);
                    previous30Days.setDate(today.getDate() - 30);
                    const lastMonth = new Date(today);
                    lastMonth.setMonth(today.getMonth() - 1);

                    if (sessionTime >= today) {
                        groupedHistory.today.push(chat);
                    } else if (sessionTime >= yesterday) {
                        groupedHistory.yesterday.push(chat);
                    } else if (sessionTime >= previous7Days) {
                        groupedHistory.previous_7_days.push(chat);
                    } else if (sessionTime >= previous30Days) {
                        groupedHistory.previous_30_days.push(chat);
                    } else if (sessionTime >= lastMonth) {
                        groupedHistory.last_month.push(chat);
                    }
                }

                setHistory({ ...groupedHistory });
            }
        })();

        effectRan.current = true;
    }, []);

    const ChatSessions = ({ title, chatSessions }) => {
        if (chatSessions.length) {
            return (
                <ul className="list-unstyled tif-mb-20">
                    <li>
                        <h2 className="tif-h4 fw-bold tif-mb-20">{title}</h2>
                        <ul className="list-unstyled tif-mb-0">
                            {
                                chatSessions.map((chat, index) => (
                                    <Link to={`/history/${chat.session_id}`} className="tif-color-golf text-decoration-none" key={index}>
                                        <li key={index} className="chat-session tif-py-md-20 tif-py-15 tif-px-md-25 tif-px-20">
                                            {chat.user_message}
                                        </li>
                                    </Link>
                                ))
                            }
                        </ul>
                    </li >
                </ul>
            );
        }

        return null;
    };

    return (
        <>
            <div id="history" className="d-flex">
                <Sidebar />
                <div className="flex-grow-1">
                    <Topbar title="Chat History" backButton />
                    <div className="content-wrapper tif-pt-md-50 tif-pt-25 tif-px-md-60 tif-px-30 tif-pb-85 tif-pb-45">
                        <ChatSessions title="Today" chatSessions={history.today} />
                        <ChatSessions title="Yesterday" chatSessions={history.yesterday} />
                        <ChatSessions title="Previous 7 Days" chatSessions={history.previous_7_days} />
                        <ChatSessions title="Previous 30 Days" chatSessions={history.previous_30_days} />
                        <ChatSessions title="Last Month" chatSessions={history.last_month} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default History;
